export default __webpack_public_path__ + "GDB.9df653c.png";